import { supabaseConfig } from '../config/environment';

export interface SubmitCareerApplicationResult {
  success: boolean;
  application_id?: string;
  message?: string;
  error?: string;
}

/** Multipart POST — use fetch directly (supabase.functions.invoke can break FormData). */
export async function submitCareerApplication(
  formData: FormData,
): Promise<SubmitCareerApplicationResult> {
  const url = supabaseConfig.url;
  const anonKey = supabaseConfig.anonKey;
  if (!url || !anonKey) {
    throw new Error('Application service is not configured.');
  }

  const res = await fetch(`${url}/functions/v1/submit-job-application`, {
    method: 'POST',
    headers: {
      apikey: anonKey,
      Authorization: `Bearer ${anonKey}`,
    },
    body: formData,
  });

  const data = (await res.json().catch(() => ({}))) as SubmitCareerApplicationResult & {
    message?: string;
    details?: string[];
  };

  if (!res.ok || !data.success) {
    const code = data.error ?? `http_${res.status}`;
    const friendly: Record<string, string> = {
      resume_upload_failed: 'Could not upload your resume. Please try a PDF under 5 MB.',
      db_insert_failed: 'Could not save your application. Please try again in a moment.',
      career_post_not_found: 'This job opening is no longer available.',
      validation_failed: 'Please check the form and try again.',
      internal_error: data.message ?? 'Something went wrong. Please try again.',
    };
    throw new Error(friendly[code] ?? data.message ?? 'Submission failed. Please try again.');
  }

  return data;
}
